import { SagaIterator } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { FetchPrivateConnectionsRequest } from '~src/bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { sitesAndTenantsInfoRequestSucceeded } from '~src/siteManagement/actions/SitesAndTenantsInfoRequestAction';
import { getSitesAndTenantsInfoRequest } from '~src/siteManagement/sagas/SitesSagas';
import { selectSitesAndTenantsInfo } from '~src/siteManagement/selectors/SitesSelectors';
import { ISitesAndTenantsInfo } from '~src/siteManagement/serverApi/types/ISitesAndTenantsInfo';

import { FetchPrivateConnectionsRequestAction, fetchPrivateConnectionsRequestSucceeded } from '../actions/FetchPrivateConnectionsRequestAction';
import { IPrivateConnectionInfo } from '../models/PrivateConnectModels';
import { callGetPrivateConnections } from '../serverApi/requests/GetPrivateConnections';
import { getTenantIdforCurrentSite } from '../utils/Helpers';


export function* handleFetchPrivateConnectionsRequest(action: FetchPrivateConnectionsRequestAction) {
    try {
      let sitesAndTenantsInfo: ISitesAndTenantsInfo = yield select(selectSitesAndTenantsInfo);
      if(sitesAndTenantsInfo?.sitesInfo ?? [] .length === 0){
        sitesAndTenantsInfo = yield call(getSitesAndTenantsInfoRequest);
        yield put(sitesAndTenantsInfoRequestSucceeded(sitesAndTenantsInfo));
      }
      const tenantId = getTenantIdforCurrentSite(sitesAndTenantsInfo, action.server.sessionSiteLuid());
      const privateConnections: IPrivateConnectionInfo[] = yield call(callGetPrivateConnections, {tenantId: tenantId, siteId: action.server.sessionSiteLuid()});
      yield put(fetchPrivateConnectionsRequestSucceeded(privateConnections));
    } catch(e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }

export function* rootPrivateConnectionsSagas(): SagaIterator {
    yield takeLatest(FetchPrivateConnectionsRequest, handleFetchPrivateConnectionsRequest);
  }